import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';
import { Button } from '../UI/button';

export default function LandingCTA() {
  const { t } = useLocale();

  return (
    <section className={`${themeClasses.landing.section} bg-background-secondary`}>
      <div className={themeClasses.landing.container}>
        <div className={themeClasses.landing.ctaBand}>
          <div className="mesh-gradient-hero opacity-50" aria-hidden />
          <div className="relative z-10 flex flex-col items-center text-center">
            <h2 className="text-display-md max-w-xl">{t('landingCtaBandTitle')}</h2>
            <p className="text-body-lg mt-4 max-w-lg">{t('landingCtaBandSubtitle')}</p>
            <Button variant="default" size="pill" className="mt-8" asChild>
              <Link to="/login">{t('landingCtaBandButton')}</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
